import SkeletonPreloader from './skeleton-preloader';

export default SkeletonPreloader;